// react
import { useCallback } from 'react';

// components
import { useLocalStorageJson } from '@/hooks/useLocalStorageJson';

const STORAGE_KEY = 'analysisPreferences';

const DEFAULT_ANALYSIS_PREFERENCES = {
  aggregation: 'mean',
};

// Persists browser-level analysis settings (e.g. last used aggregation) so
// that analyses default to what the user last picked instead of always
// falling back to the same hardcoded default.
export function useAnalysisPreferences() {
  const [preferences, setPreferences] = useLocalStorageJson(
    STORAGE_KEY,
    DEFAULT_ANALYSIS_PREFERENCES,
  );

  const setPreference = useCallback(
    (key, value) => {
      setPreferences((prev) => ({ ...prev, [key]: value }));
    },
    [setPreferences],
  );

  return { preferences, setPreference };
}
